/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Domain_BlueprintInputs */

const en_extra_domain_blueprint = /** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Domain Blueprint`)
};

const id_extra_domain_blueprint = /** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cetak Biru Domain Ekstra`)
};

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const es_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const fr_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const de_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const ja_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const zh_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const ar_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const it_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const ru_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const pt_extra_domain_blueprint = en_extra_domain_blueprint;

/** @type {(inputs: Extra_Domain_BlueprintInputs) => LocalizedString} */
const ko_extra_domain_blueprint = en_extra_domain_blueprint;

/**
* | output |
* | --- |
* | "Extra Domain Blueprint" |
*
* @param {Extra_Domain_BlueprintInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const extra_domain_blueprint = /** @type {((inputs?: Extra_Domain_BlueprintInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Domain_BlueprintInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_extra_domain_blueprint(inputs)
	if (locale === "es") return es_extra_domain_blueprint(inputs)
	if (locale === "fr") return fr_extra_domain_blueprint(inputs)
	if (locale === "de") return de_extra_domain_blueprint(inputs)
	if (locale === "ja") return ja_extra_domain_blueprint(inputs)
	if (locale === "zh") return zh_extra_domain_blueprint(inputs)
	if (locale === "ar") return ar_extra_domain_blueprint(inputs)
	if (locale === "id") return id_extra_domain_blueprint(inputs)
	if (locale === "it") return it_extra_domain_blueprint(inputs)
	if (locale === "ru") return ru_extra_domain_blueprint(inputs)
	if (locale === "pt") return pt_extra_domain_blueprint(inputs)
	return ko_extra_domain_blueprint(inputs)
});